// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1.0.0-alpha3
// @Generated: 2020-04-08T00:36:50.301Z
//
// This file is generated on each build. Do not edit this file!

import { pluginFactoryNoConfig } from '../utils/plugins'

// Icon helper component
import { BIcon } from './icon'

// Icon stacking component
import { BIconstack } from './iconstack'

import {
  // BootstrapVue custom icons
  BIconBlank,
  // Bootstrap icons
  BIconAlarm,
  BIconAlarmFill,
  BIconAlt,
  BIconApp,
  BIconAppIndicator,
  BIconArchive,
  BIconArchiveFill,
  BIconArrow90degDown,
  BIconArrow90degLeft,
  BIconArrow90degRight,
  BIconArrow90degUp,
  BIconArrowBarDown,
  BIconArrowBarLeft,
  BIconArrowBarRight,
  BIconArrowBarUp,
  BIconArrowClockwise,
  BIconArrowCounterclockwise,
  BIconArrowDown,
  BIconArrowDownLeft,
  BIconArrowDownRight,
  BIconArrowDownShort,
  BIconArrowLeft,
  BIconArrowLeftRight,
  BIconArrowLeftShort,
  BIconArrowRepeat,
  BIconArrowReturnLeft,
  BIconArrowReturnRight,
  BIconArrowRight,
  BIconArrowRightShort,
  BIconArrowUp,
  BIconArrowUpDown,
  BIconArrowUpLeft,
  BIconArrowUpRight,
  BIconArrowUpShort,
  BIconArrowsAngleContract,
  BIconArrowsAngleExpand,
  BIconArrowsCollapse,
  BIconArrowsExpand,
  BIconArrowsFullscreen,
  BIconArrowsMove,
  BIconAspectRatio,
  BIconAspectRatioFill,
  BIconAt,
  BIconAward,
  BIconAwardFill,
  BIconBackspace,
  BIconBackspaceFill,
  BIconBackspaceReverse,
  BIconBackspaceReverseFill,
  BIconBag,
  BIconBagFill,
  BIconBarChart,
  BIconBarChartFill,
  BIconBattery,
  BIconBatteryCharging,
  BIconBatteryFull,
  BIconBatteryHalf,
  BIconBell,
  BIconBellFill,
  BIconBlockquoteLeft,
  BIconBlockquoteRight,
  BIconBook,
  BIconBookHalf,
  BIconBookmark,
  BIconBookmarkCheck,
  BIconBookmarkDash,
  BIconBookmarkFill,
  BIconBookmarkPlus,
  BIconBookmarks,
  BIconBookmarksFill,
  BIconBootstrap,
  BIconBootstrapFill,
  BIconBootstrapReboot,
  BIconBoundingBox,
  BIconBoundingBoxCircles,
  BIconBoxArrowDown,
  BIconBoxArrowDownLeft,
  BIconBoxArrowDownRight,
  BIconBoxArrowInDown,
  BIconBoxArrowInDownLeft,
  BIconBoxArrowInDownRight,
  BIconBoxArrowInLeft,
  BIconBoxArrowInRight,
  BIconBoxArrowInUp,
  BIconBoxArrowInUpLeft,
  BIconBoxArrowInUpRight,
  BIconBoxArrowLeft,
  BIconBoxArrowRight,
  BIconBoxArrowUp,
  BIconBoxArrowUpLeft,
  BIconBoxArrowUpRight,
  BIconBraces,
  BIconBriefcase,
  BIconBriefcaseFill,
  BIconBrightnessAltHigh,
  BIconBrightnessAltHighFill,
  BIconBrightnessAltLow,
  BIconBrightnessAltLowFill,
  BIconBrightnessHigh,
  BIconBrightnessHighFill,
  BIconBrightnessLow,
  BIconBrightnessLowFill,
  BIconBrush,
  BIconBucket,
  BIconBucketFill,
  BIconBuilding,
  BIconBullseye,
  BIconCalendar,
  BIconCalendarFill,
  BIconCamera,
  BIconCameraVideo,
  BIconCameraVideoFill,
  BIconCapslock,
  BIconCapslockFill,
  BIconCardChecklist,
  BIconCardHeading,
  BIconCardImage,
  BIconCardList,
  BIconCardText,
  BIconCaretDown,
  BIconCaretDownFill,
  BIconCaretLeft,
  BIconCaretLeftFill,
  BIconCaretRight,
  BIconCaretRightFill,
  BIconCaretUp,
  BIconCaretUpFill,
  BIconChat,
  BIconChatDots,
  BIconChatDotsFill,
  BIconChatFill,
  BIconChatQuote,
  BIconChatQuoteFill,
  BIconChatSquare,
  BIconChatSquareDots,
  BIconChatSquareDotsFill,
  BIconChatSquareFill,
  BIconChatSquareQuote,
  BIconChatSquareQuoteFill,
  BIconCheck,
  BIconCheckAll,
  BIconCheckBox,
  BIconCheckCircle,
  BIconChevronBarContract,
  BIconChevronBarDown,
  BIconChevronBarExpand,
  BIconChevronBarLeft,
  BIconChevronBarRight,
  BIconChevronBarUp,
  BIconChevronCompactDown,
  BIconChevronCompactLeft,
  BIconChevronCompactRight,
  BIconChevronCompactUp,
  BIconChevronContract,
  BIconChevronDoubleDown,
  BIconChevronDoubleLeft,
  BIconChevronDoubleRight,
  BIconChevronDoubleUp,
  BIconChevronDown,
  BIconChevronExpand,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronUp,
  BIconCircle,
  BIconCircleFill,
  BIconCircleHalf,
  BIconCircleSquare,
  BIconClipboard,
  BIconClipboardData,
  BIconClock,
  BIconClockFill,
  BIconClockHistory,
  BIconCloud,
  BIconCloudDownload,
  BIconCloudFill,
  BIconCloudUpload,
  BIconCode,
  BIconCodeSlash,
  BIconCollection,
  BIconCollectionFill,
  BIconCollectionPlay,
  BIconCollectionPlayFill,
  BIconColumns,
  BIconColumnsGap,
  BIconCommand,
  BIconCompass,
  BIconCone,
  BIconConeStriped,
  BIconController,
  BIconCreditCard,
  BIconCrop,
  BIconCursor,
  BIconCursorFill,
  BIconCursorText,
  BIconDash,
  BIconDashCircle,
  BIconDashCircleFill,
  BIconDashSquare,
  BIconDashSquareFill,
  BIconDiamond,
  BIconDiamondFill,
  BIconDiamondHalf,
  BIconDisplay,
  BIconDisplayFill,
  BIconDot,
  BIconDownload,
  BIconDroplet,
  BIconDropletFill,
  BIconDropletHalf,
  BIconEgg,
  BIconEggFill,
  BIconEggFried,
  BIconEject,
  BIconEjectFill,
  BIconEnvelope,
  BIconEnvelopeFill,
  BIconEnvelopeOpen,
  BIconEnvelopeOpenFill,
  BIconExclamation,
  BIconExclamationCircle,
  BIconExclamationCircleFill,
  BIconExclamationDiamond,
  BIconExclamationDiamondFill,
  BIconExclamationOctagon,
  BIconExclamationOctagonFill,
  BIconExclamationSquare,
  BIconExclamationSquareFill,
  BIconExclamationTriangle,
  BIconExclamationTriangleFill,
  BIconExclude,
  BIconEye,
  BIconEyeFill,
  BIconEyeSlash,
  BIconEyeSlashFill,
  BIconFile,
  BIconFileArrowDown,
  BIconFileArrowUp,
  BIconFileBreak,
  BIconFileCheck,
  BIconFileCode,
  BIconFileDiff,
  BIconFileEarmark,
  BIconFileEarmarkArrowDown,
  BIconFileEarmarkArrowUp,
  BIconFileEarmarkBreak,
  BIconFileEarmarkCheck,
  BIconFileEarmarkCode,
  BIconFileEarmarkDiff,
  BIconFileEarmarkMinus,
  BIconFileEarmarkPlus,
  BIconFileEarmarkRuled,
  BIconFileEarmarkSpreadsheet,
  BIconFileEarmarkText,
  BIconFileEarmarkZip,
  BIconFileMinus,
  BIconFilePlus,
  BIconFilePost,
  BIconFileRichtext,
  BIconFileRuled,
  BIconFileSpreadsheet,
  BIconFileText,
  BIconFileZip,
  BIconFiles,
  BIconFilesAlt,
  BIconFilm,
  BIconFilter,
  BIconFilterLeft,
  BIconFilterRight,
  BIconFlag,
  BIconFlagFill,
  BIconFolder,
  BIconFolderCheck,
  BIconFolderFill,
  BIconFolderMinus,
  BIconFolderPlus,
  BIconFolderSymlink,
  BIconFolderSymlinkFill,
  BIconFonts,
  BIconForward,
  BIconForwardFill,
  BIconFullscreen,
  BIconFullscreenExit,
  BIconFunnel,
  BIconFunnelFill,
  BIconGear,
  BIconGearFill,
  BIconGearWide,
  BIconGearWideConnected,
  BIconGem,
  BIconGeo,
  BIconGeoAlt,
  BIconGift,
  BIconGiftFill,
  BIconGraphDown,
  BIconGraphUp,
  BIconGrid,
  BIconGrid1x2,
  BIconGrid1x2Fill,
  BIconGrid3x2,
  BIconGrid3x2Gap,
  BIconGrid3x2GapFill,
  BIconGrid3x3,
  BIconGrid3x3Gap,
  BIconGrid3x3GapFill,
  BIconGridFill,
  BIconHammer,
  BIconHash,
  BIconHeart,
  BIconHeartFill,
  BIconHeartHalf,
  BIconHouse,
  BIconHouseDoor,
  BIconHouseDoorFill,
  BIconHouseFill,
  BIconHr,
  BIconImage,
  BIconImageAlt,
  BIconImageFill,
  BIconImages,
  BIconInbox,
  BIconInboxFill,
  BIconInboxes,
  BIconInboxesFill,
  BIconInfo,
  BIconInfoCircle,
  BIconInfoCircleFill,
  BIconInfoSquare,
  BIconInfoSquareFill,
  BIconIntersect,
  BIconJustify,
  BIconJustifyLeft,
  BIconJustifyRight,
  BIconKanban,
  BIconKanbanFill,
  BIconLaptop,
  BIconLayers,
  BIconLayersFill,
  BIconLayersHalf,
  BIconLayoutSidebar,
  BIconLayoutSidebarInset,
  BIconLayoutSidebarInsetReverse,
  BIconLayoutSidebarReverse,
  BIconLayoutSplit,
  BIconLayoutTextSidebar,
  BIconLayoutTextSidebarReverse,
  BIconLayoutTextWindow,
  BIconLayoutTextWindowReverse,
  BIconLayoutThreeColumns,
  BIconLayoutWtf,
  BIconLifePreserver,
  BIconLightning,
  BIconLightningFill,
  BIconLink,
  BIconLink45deg,
  BIconList,
  BIconListCheck,
  BIconListNested,
  BIconListOl,
  BIconListTask,
  BIconListUl,
  BIconLock,
  BIconLockFill,
  BIconMap,
  BIconMic,
  BIconMicFill,
  BIconMicMute,
  BIconMicMuteFill,
  BIconMoon,
  BIconMusicNote,
  BIconMusicNoteBeamed,
  BIconMusicNoteList,
  BIconMusicPlayer,
  BIconMusicPlayerFill,
  BIconNewspaper,
  BIconOctagon,
  BIconOctagonFill,
  BIconOctagonHalf,
  BIconOption,
  BIconOutlet,
  BIconPaperclip,
  BIconPause,
  BIconPauseFill,
  BIconPen,
  BIconPencil,
  BIconPencilSquare,
  BIconPentagon,
  BIconPentagonFill,
  BIconPentagonHalf,
  BIconPeople,
  BIconPeopleCircle,
  BIconPeopleFill,
  BIconPerson,
  BIconPersonBoundingBox,
  BIconPersonCheck,
  BIconPersonCheckFill,
  BIconPersonDash,
  BIconPersonDashFill,
  BIconPersonFill,
  BIconPersonLinesFill,
  BIconPersonPlus,
  BIconPersonPlusFill,
  BIconPersonSquare,
  BIconPhone,
  BIconPhoneLandscape,
  BIconPieChart,
  BIconPieChartFill,
  BIconPip,
  BIconPipFill,
  BIconPlay,
  BIconPlayFill,
  BIconPlug,
  BIconPlus,
  BIconPlusCircle,
  BIconPlusCircleFill,
  BIconPlusSquare,
  BIconPlusSquareFill,
  BIconPower,
  BIconPuzzle,
  BIconPuzzleFill,
  BIconQuestion,
  BIconQuestionCircle,
  BIconQuestionCircleFill,
  BIconQuestionDiamond,
  BIconQuestionDiamondFill,
  BIconQuestionOctagon,
  BIconQuestionOctagonFill,
  BIconQuestionSquare,
  BIconQuestionSquareFill,
  BIconReply,
  BIconReplyAll,
  BIconReplyAllFill,
  BIconReplyFill,
  BIconScrewdriver,
  BIconSearch,
  BIconServer,
  BIconShield,
  BIconShieldFill,
  BIconShieldLock,
  BIconShieldLockFill,
  BIconShieldShaded,
  BIconShift,
  BIconShiftFill,
  BIconShuffle,
  BIconSkipBackward,
  BIconSkipBackwardFill,
  BIconSkipEnd,
  BIconSkipEndFill,
  BIconSkipForward,
  BIconSkipForwardFill,
  BIconSkipStart,
  BIconSkipStartFill,
  BIconSlash,
  BIconSlashCircle,
  BIconSlashCircleFill,
  BIconSlashSquare,
  BIconSlashSquareFill,
  BIconSliders,
  BIconSoundwave,
  BIconSpeaker,
  BIconSquare,
  BIconSquareFill,
  BIconSquareHalf,
  BIconStar,
  BIconStarFill,
  BIconStarHalf,
  BIconStop,
  BIconStopFill,
  BIconStopwatch,
  BIconStopwatchFill,
  BIconSubtract,
  BIconSun,
  BIconTable,
  BIconTablet,
  BIconTabletLandscape,
  BIconTag,
  BIconTagFill,
  BIconTerminal,
  BIconTerminalFill,
  BIconTextCenter,
  BIconTextIndentLeft,
  BIconTextIndentRight,
  BIconTextLeft,
  BIconTextRight,
  BIconTextarea,
  BIconTextareaT,
  BIconThreeDots,
  BIconThreeDotsVertical,
  BIconToggleOff,
  BIconToggleOn,
  BIconToggles,
  BIconTools,
  BIconTrash,
  BIconTrash2,
  BIconTrash2Fill,
  BIconTrashFill,
  BIconTriangle,
  BIconTriangleFill,
  BIconTriangleHalf,
  BIconTrophy,
  BIconTv,
  BIconTvFill,
  BIconType,
  BIconTypeBold,
  BIconTypeH1,
  BIconTypeH2,
  BIconTypeH3,
  BIconTypeItalic,
  BIconTypeStrikethrough,
  BIconTypeUnderline,
  BIconUnion,
  BIconUnlock,
  BIconUnlockFill,
  BIconUpload,
  BIconViewList,
  BIconViewStacked,
  BIconVolumeDown,
  BIconVolumeDownFill,
  BIconVolumeMute,
  BIconVolumeMuteFill,
  BIconVolumeUp,
  BIconVolumeUpFill,
  BIconVr,
  BIconWallet,
  BIconWatch,
  BIconWifi,
  BIconWindow,
  BIconWrench,
  BIconX,
  BIconXCircle,
  BIconXCircleFill,
  BIconXDiamond,
  BIconXDiamondFill,
  BIconXOctagon,
  BIconXOctagonFill,
  BIconXSquare,
  BIconXSquareFill
} from './icons'

// Icon component names for used in the docs
export const iconNames = [
  // BootstrapVue custom icon component names
  'BIconBlank',
  // Bootstrap icon component names
  'BIconAlarm',
  'BIconAlarmFill',
  'BIconAlt',
  'BIconApp',
  'BIconAppIndicator',
  'BIconArchive',
  'BIconArchiveFill',
  'BIconArrow90degDown',
  'BIconArrow90degLeft',
  'BIconArrow90degRight',
  'BIconArrow90degUp',
  'BIconArrowBarDown',
  'BIconArrowBarLeft',
  'BIconArrowBarRight',
  'BIconArrowBarUp',
  'BIconArrowClockwise',
  'BIconArrowCounterclockwise',
  'BIconArrowDown',
  'BIconArrowDownLeft',
  'BIconArrowDownRight',
  'BIconArrowDownShort',
  'BIconArrowLeft',
  'BIconArrowLeftRight',
  'BIconArrowLeftShort',
  'BIconArrowRepeat',
  'BIconArrowReturnLeft',
  'BIconArrowReturnRight',
  'BIconArrowRight',
  'BIconArrowRightShort',
  'BIconArrowUp',
  'BIconArrowUpDown',
  'BIconArrowUpLeft',
  'BIconArrowUpRight',
  'BIconArrowUpShort',
  'BIconArrowsAngleContract',
  'BIconArrowsAngleExpand',
  'BIconArrowsCollapse',
  'BIconArrowsExpand',
  'BIconArrowsFullscreen',
  'BIconArrowsMove',
  'BIconAspectRatio',
  'BIconAspectRatioFill',
  'BIconAt',
  'BIconAward',
  'BIconAwardFill',
  'BIconBackspace',
  'BIconBackspaceFill',
  'BIconBackspaceReverse',
  'BIconBackspaceReverseFill',
  'BIconBag',
  'BIconBagFill',
  'BIconBarChart',
  'BIconBarChartFill',
  'BIconBattery',
  'BIconBatteryCharging',
  'BIconBatteryFull',
  'BIconBatteryHalf',
  'BIconBell',
  'BIconBellFill',
  'BIconBlockquoteLeft',
  'BIconBlockquoteRight',
  'BIconBook',
  'BIconBookHalf',
  'BIconBookmark',
  'BIconBookmarkCheck',
  'BIconBookmarkDash',
  'BIconBookmarkFill',
  'BIconBookmarkPlus',
  'BIconBookmarks',
  'BIconBookmarksFill',
  'BIconBootstrap',
  'BIconBootstrapFill',
  'BIconBootstrapReboot',
  'BIconBoundingBox',
  'BIconBoundingBoxCircles',
  'BIconBoxArrowDown',
  'BIconBoxArrowDownLeft',
  'BIconBoxArrowDownRight',
  'BIconBoxArrowInDown',
  'BIconBoxArrowInDownLeft',
  'BIconBoxArrowInDownRight',
  'BIconBoxArrowInLeft',
  'BIconBoxArrowInRight',
  'BIconBoxArrowInUp',
  'BIconBoxArrowInUpLeft',
  'BIconBoxArrowInUpRight',
  'BIconBoxArrowLeft',
  'BIconBoxArrowRight',
  'BIconBoxArrowUp',
  'BIconBoxArrowUpLeft',
  'BIconBoxArrowUpRight',
  'BIconBraces',
  'BIconBriefcase',
  'BIconBriefcaseFill',
  'BIconBrightnessAltHigh',
  'BIconBrightnessAltHighFill',
  'BIconBrightnessAltLow',
  'BIconBrightnessAltLowFill',
  'BIconBrightnessHigh',
  'BIconBrightnessHighFill',
  'BIconBrightnessLow',
  'BIconBrightnessLowFill',
  'BIconBrush',
  'BIconBucket',
  'BIconBucketFill',
  'BIconBuilding',
  'BIconBullseye',
  'BIconCalendar',
  'BIconCalendarFill',
  'BIconCamera',
  'BIconCameraVideo',
  'BIconCameraVideoFill',
  'BIconCapslock',
  'BIconCapslockFill',
  'BIconCardChecklist',
  'BIconCardHeading',
  'BIconCardImage',
  'BIconCardList',
  'BIconCardText',
  'BIconCaretDown',
  'BIconCaretDownFill',
  'BIconCaretLeft',
  'BIconCaretLeftFill',
  'BIconCaretRight',
  'BIconCaretRightFill',
  'BIconCaretUp',
  'BIconCaretUpFill',
  'BIconChat',
  'BIconChatDots',
  'BIconChatDotsFill',
  'BIconChatFill',
  'BIconChatQuote',
  'BIconChatQuoteFill',
  'BIconChatSquare',
  'BIconChatSquareDots',
  'BIconChatSquareDotsFill',
  'BIconChatSquareFill',
  'BIconChatSquareQuote',
  'BIconChatSquareQuoteFill',
  'BIconCheck',
  'BIconCheckAll',
  'BIconCheckBox',
  'BIconCheckCircle',
  'BIconChevronBarContract',
  'BIconChevronBarDown',
  'BIconChevronBarExpand',
  'BIconChevronBarLeft',
  'BIconChevronBarRight',
  'BIconChevronBarUp',
  'BIconChevronCompactDown',
  'BIconChevronCompactLeft',
  'BIconChevronCompactRight',
  'BIconChevronCompactUp',
  'BIconChevronContract',
  'BIconChevronDoubleDown',
  'BIconChevronDoubleLeft',
  'BIconChevronDoubleRight',
  'BIconChevronDoubleUp',
  'BIconChevronDown',
  'BIconChevronExpand',
  'BIconChevronLeft',
  'BIconChevronRight',
  'BIconChevronUp',
  'BIconCircle',
  'BIconCircleFill',
  'BIconCircleHalf',
  'BIconCircleSquare',
  'BIconClipboard',
  'BIconClipboardData',
  'BIconClock',
  'BIconClockFill',
  'BIconClockHistory',
  'BIconCloud',
  'BIconCloudDownload',
  'BIconCloudFill',
  'BIconCloudUpload',
  'BIconCode',
  'BIconCodeSlash',
  'BIconCollection',
  'BIconCollectionFill',
  'BIconCollectionPlay',
  'BIconCollectionPlayFill',
  'BIconColumns',
  'BIconColumnsGap',
  'BIconCommand',
  'BIconCompass',
  'BIconCone',
  'BIconConeStriped',
  'BIconController',
  'BIconCreditCard',
  'BIconCrop',
  'BIconCursor',
  'BIconCursorFill',
  'BIconCursorText',
  'BIconDash',
  'BIconDashCircle',
  'BIconDashCircleFill',
  'BIconDashSquare',
  'BIconDashSquareFill',
  'BIconDiamond',
  'BIconDiamondFill',
  'BIconDiamondHalf',
  'BIconDisplay',
  'BIconDisplayFill',
  'BIconDot',
  'BIconDownload',
  'BIconDroplet',
  'BIconDropletFill',
  'BIconDropletHalf',
  'BIconEgg',
  'BIconEggFill',
  'BIconEggFried',
  'BIconEject',
  'BIconEjectFill',
  'BIconEnvelope',
  'BIconEnvelopeFill',
  'BIconEnvelopeOpen',
  'BIconEnvelopeOpenFill',
  'BIconExclamation',
  'BIconExclamationCircle',
  'BIconExclamationCircleFill',
  'BIconExclamationDiamond',
  'BIconExclamationDiamondFill',
  'BIconExclamationOctagon',
  'BIconExclamationOctagonFill',
  'BIconExclamationSquare',
  'BIconExclamationSquareFill',
  'BIconExclamationTriangle',
  'BIconExclamationTriangleFill',
  'BIconExclude',
  'BIconEye',
  'BIconEyeFill',
  'BIconEyeSlash',
  'BIconEyeSlashFill',
  'BIconFile',
  'BIconFileArrowDown',
  'BIconFileArrowUp',
  'BIconFileBreak',
  'BIconFileCheck',
  'BIconFileCode',
  'BIconFileDiff',
  'BIconFileEarmark',
  'BIconFileEarmarkArrowDown',
  'BIconFileEarmarkArrowUp',
  'BIconFileEarmarkBreak',
  'BIconFileEarmarkCheck',
  'BIconFileEarmarkCode',
  'BIconFileEarmarkDiff',
  'BIconFileEarmarkMinus',
  'BIconFileEarmarkPlus',
  'BIconFileEarmarkRuled',
  'BIconFileEarmarkSpreadsheet',
  'BIconFileEarmarkText',
  'BIconFileEarmarkZip',
  'BIconFileMinus',
  'BIconFilePlus',
  'BIconFilePost',
  'BIconFileRichtext',
  'BIconFileRuled',
  'BIconFileSpreadsheet',
  'BIconFileText',
  'BIconFileZip',
  'BIconFiles',
  'BIconFilesAlt',
  'BIconFilm',
  'BIconFilter',
  'BIconFilterLeft',
  'BIconFilterRight',
  'BIconFlag',
  'BIconFlagFill',
  'BIconFolder',
  'BIconFolderCheck',
  'BIconFolderFill',
  'BIconFolderMinus',
  'BIconFolderPlus',
  'BIconFolderSymlink',
  'BIconFolderSymlinkFill',
  'BIconFonts',
  'BIconForward',
  'BIconForwardFill',
  'BIconFullscreen',
  'BIconFullscreenExit',
  'BIconFunnel',
  'BIconFunnelFill',
  'BIconGear',
  'BIconGearFill',
  'BIconGearWide',
  'BIconGearWideConnected',
  'BIconGem',
  'BIconGeo',
  'BIconGeoAlt',
  'BIconGift',
  'BIconGiftFill',
  'BIconGraphDown',
  'BIconGraphUp',
  'BIconGrid',
  'BIconGrid1x2',
  'BIconGrid1x2Fill',
  'BIconGrid3x2',
  'BIconGrid3x2Gap',
  'BIconGrid3x2GapFill',
  'BIconGrid3x3',
  'BIconGrid3x3Gap',
  'BIconGrid3x3GapFill',
  'BIconGridFill',
  'BIconHammer',
  'BIconHash',
  'BIconHeart',
  'BIconHeartFill',
  'BIconHeartHalf',
  'BIconHouse',
  'BIconHouseDoor',
  'BIconHouseDoorFill',
  'BIconHouseFill',
  'BIconHr',
  'BIconImage',
  'BIconImageAlt',
  'BIconImageFill',
  'BIconImages',
  'BIconInbox',
  'BIconInboxFill',
  'BIconInboxes',
  'BIconInboxesFill',
  'BIconInfo',
  'BIconInfoCircle',
  'BIconInfoCircleFill',
  'BIconInfoSquare',
  'BIconInfoSquareFill',
  'BIconIntersect',
  'BIconJustify',
  'BIconJustifyLeft',
  'BIconJustifyRight',
  'BIconKanban',
  'BIconKanbanFill',
  'BIconLaptop',
  'BIconLayers',
  'BIconLayersFill',
  'BIconLayersHalf',
  'BIconLayoutSidebar',
  'BIconLayoutSidebarInset',
  'BIconLayoutSidebarInsetReverse',
  'BIconLayoutSidebarReverse',
  'BIconLayoutSplit',
  'BIconLayoutTextSidebar',
  'BIconLayoutTextSidebarReverse',
  'BIconLayoutTextWindow',
  'BIconLayoutTextWindowReverse',
  'BIconLayoutThreeColumns',
  'BIconLayoutWtf',
  'BIconLifePreserver',
  'BIconLightning',
  'BIconLightningFill',
  'BIconLink',
  'BIconLink45deg',
  'BIconList',
  'BIconListCheck',
  'BIconListNested',
  'BIconListOl',
  'BIconListTask',
  'BIconListUl',
  'BIconLock',
  'BIconLockFill',
  'BIconMap',
  'BIconMic',
  'BIconMicFill',
  'BIconMicMute',
  'BIconMicMuteFill',
  'BIconMoon',
  'BIconMusicNote',
  'BIconMusicNoteBeamed',
  'BIconMusicNoteList',
  'BIconMusicPlayer',
  'BIconMusicPlayerFill',
  'BIconNewspaper',
  'BIconOctagon',
  'BIconOctagonFill',
  'BIconOctagonHalf',
  'BIconOption',
  'BIconOutlet',
  'BIconPaperclip',
  'BIconPause',
  'BIconPauseFill',
  'BIconPen',
  'BIconPencil',
  'BIconPencilSquare',
  'BIconPentagon',
  'BIconPentagonFill',
  'BIconPentagonHalf',
  'BIconPeople',
  'BIconPeopleCircle',
  'BIconPeopleFill',
  'BIconPerson',
  'BIconPersonBoundingBox',
  'BIconPersonCheck',
  'BIconPersonCheckFill',
  'BIconPersonDash',
  'BIconPersonDashFill',
  'BIconPersonFill',
  'BIconPersonLinesFill',
  'BIconPersonPlus',
  'BIconPersonPlusFill',
  'BIconPersonSquare',
  'BIconPhone',
  'BIconPhoneLandscape',
  'BIconPieChart',
  'BIconPieChartFill',
  'BIconPip',
  'BIconPipFill',
  'BIconPlay',
  'BIconPlayFill',
  'BIconPlug',
  'BIconPlus',
  'BIconPlusCircle',
  'BIconPlusCircleFill',
  'BIconPlusSquare',
  'BIconPlusSquareFill',
  'BIconPower',
  'BIconPuzzle',
  'BIconPuzzleFill',
  'BIconQuestion',
  'BIconQuestionCircle',
  'BIconQuestionCircleFill',
  'BIconQuestionDiamond',
  'BIconQuestionDiamondFill',
  'BIconQuestionOctagon',
  'BIconQuestionOctagonFill',
  'BIconQuestionSquare',
  'BIconQuestionSquareFill',
  'BIconReply',
  'BIconReplyAll',
  'BIconReplyAllFill',
  'BIconReplyFill',
  'BIconScrewdriver',
  'BIconSearch',
  'BIconServer',
  'BIconShield',
  'BIconShieldFill',
  'BIconShieldLock',
  'BIconShieldLockFill',
  'BIconShieldShaded',
  'BIconShift',
  'BIconShiftFill',
  'BIconShuffle',
  'BIconSkipBackward',
  'BIconSkipBackwardFill',
  'BIconSkipEnd',
  'BIconSkipEndFill',
  'BIconSkipForward',
  'BIconSkipForwardFill',
  'BIconSkipStart',
  'BIconSkipStartFill',
  'BIconSlash',
  'BIconSlashCircle',
  'BIconSlashCircleFill',
  'BIconSlashSquare',
  'BIconSlashSquareFill',
  'BIconSliders',
  'BIconSoundwave',
  'BIconSpeaker',
  'BIconSquare',
  'BIconSquareFill',
  'BIconSquareHalf',
  'BIconStar',
  'BIconStarFill',
  'BIconStarHalf',
  'BIconStop',
  'BIconStopFill',
  'BIconStopwatch',
  'BIconStopwatchFill',
  'BIconSubtract',
  'BIconSun',
  'BIconTable',
  'BIconTablet',
  'BIconTabletLandscape',
  'BIconTag',
  'BIconTagFill',
  'BIconTerminal',
  'BIconTerminalFill',
  'BIconTextCenter',
  'BIconTextIndentLeft',
  'BIconTextIndentRight',
  'BIconTextLeft',
  'BIconTextRight',
  'BIconTextarea',
  'BIconTextareaT',
  'BIconThreeDots',
  'BIconThreeDotsVertical',
  'BIconToggleOff',
  'BIconToggleOn',
  'BIconToggles',
  'BIconTools',
  'BIconTrash',
  'BIconTrash2',
  'BIconTrash2Fill',
  'BIconTrashFill',
  'BIconTriangle',
  'BIconTriangleFill',
  'BIconTriangleHalf',
  'BIconTrophy',
  'BIconTv',
  'BIconTvFill',
  'BIconType',
  'BIconTypeBold',
  'BIconTypeH1',
  'BIconTypeH2',
  'BIconTypeH3',
  'BIconTypeItalic',
  'BIconTypeStrikethrough',
  'BIconTypeUnderline',
  'BIconUnion',
  'BIconUnlock',
  'BIconUnlockFill',
  'BIconUpload',
  'BIconViewList',
  'BIconViewStacked',
  'BIconVolumeDown',
  'BIconVolumeDownFill',
  'BIconVolumeMute',
  'BIconVolumeMuteFill',
  'BIconVolumeUp',
  'BIconVolumeUpFill',
  'BIconVr',
  'BIconWallet',
  'BIconWatch',
  'BIconWifi',
  'BIconWindow',
  'BIconWrench',
  'BIconX',
  'BIconXCircle',
  'BIconXCircleFill',
  'BIconXDiamond',
  'BIconXDiamondFill',
  'BIconXOctagon',
  'BIconXOctagonFill',
  'BIconXSquare',
  'BIconXSquareFill'
]

// Export the icons plugin
export const IconsPlugin = /*#__PURE__*/ pluginFactoryNoConfig({
  components: {
    // Icon helper component
    BIcon,
    // Icon stacking component
    BIconstack,
    // BootstrapVue custom icon components
    BIconBlank,
    // Bootstrap icon components
    BIconAlarm,
    BIconAlarmFill,
    BIconAlt,
    BIconApp,
    BIconAppIndicator,
    BIconArchive,
    BIconArchiveFill,
    BIconArrow90degDown,
    BIconArrow90degLeft,
    BIconArrow90degRight,
    BIconArrow90degUp,
    BIconArrowBarDown,
    BIconArrowBarLeft,
    BIconArrowBarRight,
    BIconArrowBarUp,
    BIconArrowClockwise,
    BIconArrowCounterclockwise,
    BIconArrowDown,
    BIconArrowDownLeft,
    BIconArrowDownRight,
    BIconArrowDownShort,
    BIconArrowLeft,
    BIconArrowLeftRight,
    BIconArrowLeftShort,
    BIconArrowRepeat,
    BIconArrowReturnLeft,
    BIconArrowReturnRight,
    BIconArrowRight,
    BIconArrowRightShort,
    BIconArrowUp,
    BIconArrowUpDown,
    BIconArrowUpLeft,
    BIconArrowUpRight,
    BIconArrowUpShort,
    BIconArrowsAngleContract,
    BIconArrowsAngleExpand,
    BIconArrowsCollapse,
    BIconArrowsExpand,
    BIconArrowsFullscreen,
    BIconArrowsMove,
    BIconAspectRatio,
    BIconAspectRatioFill,
    BIconAt,
    BIconAward,
    BIconAwardFill,
    BIconBackspace,
    BIconBackspaceFill,
    BIconBackspaceReverse,
    BIconBackspaceReverseFill,
    BIconBag,
    BIconBagFill,
    BIconBarChart,
    BIconBarChartFill,
    BIconBattery,
    BIconBatteryCharging,
    BIconBatteryFull,
    BIconBatteryHalf,
    BIconBell,
    BIconBellFill,
    BIconBlockquoteLeft,
    BIconBlockquoteRight,
    BIconBook,
    BIconBookHalf,
    BIconBookmark,
    BIconBookmarkCheck,
    BIconBookmarkDash,
    BIconBookmarkFill,
    BIconBookmarkPlus,
    BIconBookmarks,
    BIconBookmarksFill,
    BIconBootstrap,
    BIconBootstrapFill,
    BIconBootstrapReboot,
    BIconBoundingBox,
    BIconBoundingBoxCircles,
    BIconBoxArrowDown,
    BIconBoxArrowDownLeft,
    BIconBoxArrowDownRight,
    BIconBoxArrowInDown,
    BIconBoxArrowInDownLeft,
    BIconBoxArrowInDownRight,
    BIconBoxArrowInLeft,
    BIconBoxArrowInRight,
    BIconBoxArrowInUp,
    BIconBoxArrowInUpLeft,
    BIconBoxArrowInUpRight,
    BIconBoxArrowLeft,
    BIconBoxArrowRight,
    BIconBoxArrowUp,
    BIconBoxArrowUpLeft,
    BIconBoxArrowUpRight,
    BIconBraces,
    BIconBriefcase,
    BIconBriefcaseFill,
    BIconBrightnessAltHigh,
    BIconBrightnessAltHighFill,
    BIconBrightnessAltLow,
    BIconBrightnessAltLowFill,
    BIconBrightnessHigh,
    BIconBrightnessHighFill,
    BIconBrightnessLow,
    BIconBrightnessLowFill,
    BIconBrush,
    BIconBucket,
    BIconBucketFill,
    BIconBuilding,
    BIconBullseye,
    BIconCalendar,
    BIconCalendarFill,
    BIconCamera,
    BIconCameraVideo,
    BIconCameraVideoFill,
    BIconCapslock,
    BIconCapslockFill,
    BIconCardChecklist,
    BIconCardHeading,
    BIconCardImage,
    BIconCardList,
    BIconCardText,
    BIconCaretDown,
    BIconCaretDownFill,
    BIconCaretLeft,
    BIconCaretLeftFill,
    BIconCaretRight,
    BIconCaretRightFill,
    BIconCaretUp,
    BIconCaretUpFill,
    BIconChat,
    BIconChatDots,
    BIconChatDotsFill,
    BIconChatFill,
    BIconChatQuote,
    BIconChatQuoteFill,
    BIconChatSquare,
    BIconChatSquareDots,
    BIconChatSquareDotsFill,
    BIconChatSquareFill,
    BIconChatSquareQuote,
    BIconChatSquareQuoteFill,
    BIconCheck,
    BIconCheckAll,
    BIconCheckBox,
    BIconCheckCircle,
    BIconChevronBarContract,
    BIconChevronBarDown,
    BIconChevronBarExpand,
    BIconChevronBarLeft,
    BIconChevronBarRight,
    BIconChevronBarUp,
    BIconChevronCompactDown,
    BIconChevronCompactLeft,
    BIconChevronCompactRight,
    BIconChevronCompactUp,
    BIconChevronContract,
    BIconChevronDoubleDown,
    BIconChevronDoubleLeft,
    BIconChevronDoubleRight,
    BIconChevronDoubleUp,
    BIconChevronDown,
    BIconChevronExpand,
    BIconChevronLeft,
    BIconChevronRight,
    BIconChevronUp,
    BIconCircle,
    BIconCircleFill,
    BIconCircleHalf,
    BIconCircleSquare,
    BIconClipboard,
    BIconClipboardData,
    BIconClock,
    BIconClockFill,
    BIconClockHistory,
    BIconCloud,
    BIconCloudDownload,
    BIconCloudFill,
    BIconCloudUpload,
    BIconCode,
    BIconCodeSlash,
    BIconCollection,
    BIconCollectionFill,
    BIconCollectionPlay,
    BIconCollectionPlayFill,
    BIconColumns,
    BIconColumnsGap,
    BIconCommand,
    BIconCompass,
    BIconCone,
    BIconConeStriped,
    BIconController,
    BIconCreditCard,
    BIconCrop,
    BIconCursor,
    BIconCursorFill,
    BIconCursorText,
    BIconDash,
    BIconDashCircle,
    BIconDashCircleFill,
    BIconDashSquare,
    BIconDashSquareFill,
    BIconDiamond,
    BIconDiamondFill,
    BIconDiamondHalf,
    BIconDisplay,
    BIconDisplayFill,
    BIconDot,
    BIconDownload,
    BIconDroplet,
    BIconDropletFill,
    BIconDropletHalf,
    BIconEgg,
    BIconEggFill,
    BIconEggFried,
    BIconEject,
    BIconEjectFill,
    BIconEnvelope,
    BIconEnvelopeFill,
    BIconEnvelopeOpen,
    BIconEnvelopeOpenFill,
    BIconExclamation,
    BIconExclamationCircle,
    BIconExclamationCircleFill,
    BIconExclamationDiamond,
    BIconExclamationDiamondFill,
    BIconExclamationOctagon,
    BIconExclamationOctagonFill,
    BIconExclamationSquare,
    BIconExclamationSquareFill,
    BIconExclamationTriangle,
    BIconExclamationTriangleFill,
    BIconExclude,
    BIconEye,
    BIconEyeFill,
    BIconEyeSlash,
    BIconEyeSlashFill,
    BIconFile,
    BIconFileArrowDown,
    BIconFileArrowUp,
    BIconFileBreak,
    BIconFileCheck,
    BIconFileCode,
    BIconFileDiff,
    BIconFileEarmark,
    BIconFileEarmarkArrowDown,
    BIconFileEarmarkArrowUp,
    BIconFileEarmarkBreak,
    BIconFileEarmarkCheck,
    BIconFileEarmarkCode,
    BIconFileEarmarkDiff,
    BIconFileEarmarkMinus,
    BIconFileEarmarkPlus,
    BIconFileEarmarkRuled,
    BIconFileEarmarkSpreadsheet,
    BIconFileEarmarkText,
    BIconFileEarmarkZip,
    BIconFileMinus,
    BIconFilePlus,
    BIconFilePost,
    BIconFileRichtext,
    BIconFileRuled,
    BIconFileSpreadsheet,
    BIconFileText,
    BIconFileZip,
    BIconFiles,
    BIconFilesAlt,
    BIconFilm,
    BIconFilter,
    BIconFilterLeft,
    BIconFilterRight,
    BIconFlag,
    BIconFlagFill,
    BIconFolder,
    BIconFolderCheck,
    BIconFolderFill,
    BIconFolderMinus,
    BIconFolderPlus,
    BIconFolderSymlink,
    BIconFolderSymlinkFill,
    BIconFonts,
    BIconForward,
    BIconForwardFill,
    BIconFullscreen,
    BIconFullscreenExit,
    BIconFunnel,
    BIconFunnelFill,
    BIconGear,
    BIconGearFill,
    BIconGearWide,
    BIconGearWideConnected,
    BIconGem,
    BIconGeo,
    BIconGeoAlt,
    BIconGift,
    BIconGiftFill,
    BIconGraphDown,
    BIconGraphUp,
    BIconGrid,
    BIconGrid1x2,
    BIconGrid1x2Fill,
    BIconGrid3x2,
    BIconGrid3x2Gap,
    BIconGrid3x2GapFill,
    BIconGrid3x3,
    BIconGrid3x3Gap,
    BIconGrid3x3GapFill,
    BIconGridFill,
    BIconHammer,
    BIconHash,
    BIconHeart,
    BIconHeartFill,
    BIconHeartHalf,
    BIconHouse,
    BIconHouseDoor,
    BIconHouseDoorFill,
    BIconHouseFill,
    BIconHr,
    BIconImage,
    BIconImageAlt,
    BIconImageFill,
    BIconImages,
    BIconInbox,
    BIconInboxFill,
    BIconInboxes,
    BIconInboxesFill,
    BIconInfo,
    BIconInfoCircle,
    BIconInfoCircleFill,
    BIconInfoSquare,
    BIconInfoSquareFill,
    BIconIntersect,
    BIconJustify,
    BIconJustifyLeft,
    BIconJustifyRight,
    BIconKanban,
    BIconKanbanFill,
    BIconLaptop,
    BIconLayers,
    BIconLayersFill,
    BIconLayersHalf,
    BIconLayoutSidebar,
    BIconLayoutSidebarInset,
    BIconLayoutSidebarInsetReverse,
    BIconLayoutSidebarReverse,
    BIconLayoutSplit,
    BIconLayoutTextSidebar,
    BIconLayoutTextSidebarReverse,
    BIconLayoutTextWindow,
    BIconLayoutTextWindowReverse,
    BIconLayoutThreeColumns,
    BIconLayoutWtf,
    BIconLifePreserver,
    BIconLightning,
    BIconLightningFill,
    BIconLink,
    BIconLink45deg,
    BIconList,
    BIconListCheck,
    BIconListNested,
    BIconListOl,
    BIconListTask,
    BIconListUl,
    BIconLock,
    BIconLockFill,
    BIconMap,
    BIconMic,
    BIconMicFill,
    BIconMicMute,
    BIconMicMuteFill,
    BIconMoon,
    BIconMusicNote,
    BIconMusicNoteBeamed,
    BIconMusicNoteList,
    BIconMusicPlayer,
    BIconMusicPlayerFill,
    BIconNewspaper,
    BIconOctagon,
    BIconOctagonFill,
    BIconOctagonHalf,
    BIconOption,
    BIconOutlet,
    BIconPaperclip,
    BIconPause,
    BIconPauseFill,
    BIconPen,
    BIconPencil,
    BIconPencilSquare,
    BIconPentagon,
    BIconPentagonFill,
    BIconPentagonHalf,
    BIconPeople,
    BIconPeopleCircle,
    BIconPeopleFill,
    BIconPerson,
    BIconPersonBoundingBox,
    BIconPersonCheck,
    BIconPersonCheckFill,
    BIconPersonDash,
    BIconPersonDashFill,
    BIconPersonFill,
    BIconPersonLinesFill,
    BIconPersonPlus,
    BIconPersonPlusFill,
    BIconPersonSquare,
    BIconPhone,
    BIconPhoneLandscape,
    BIconPieChart,
    BIconPieChartFill,
    BIconPip,
    BIconPipFill,
    BIconPlay,
    BIconPlayFill,
    BIconPlug,
    BIconPlus,
    BIconPlusCircle,
    BIconPlusCircleFill,
    BIconPlusSquare,
    BIconPlusSquareFill,
    BIconPower,
    BIconPuzzle,
    BIconPuzzleFill,
    BIconQuestion,
    BIconQuestionCircle,
    BIconQuestionCircleFill,
    BIconQuestionDiamond,
    BIconQuestionDiamondFill,
    BIconQuestionOctagon,
    BIconQuestionOctagonFill,
    BIconQuestionSquare,
    BIconQuestionSquareFill,
    BIconReply,
    BIconReplyAll,
    BIconReplyAllFill,
    BIconReplyFill,
    BIconScrewdriver,
    BIconSearch,
    BIconServer,
    BIconShield,
    BIconShieldFill,
    BIconShieldLock,
    BIconShieldLockFill,
    BIconShieldShaded,
    BIconShift,
    BIconShiftFill,
    BIconShuffle,
    BIconSkipBackward,
    BIconSkipBackwardFill,
    BIconSkipEnd,
    BIconSkipEndFill,
    BIconSkipForward,
    BIconSkipForwardFill,
    BIconSkipStart,
    BIconSkipStartFill,
    BIconSlash,
    BIconSlashCircle,
    BIconSlashCircleFill,
    BIconSlashSquare,
    BIconSlashSquareFill,
    BIconSliders,
    BIconSoundwave,
    BIconSpeaker,
    BIconSquare,
    BIconSquareFill,
    BIconSquareHalf,
    BIconStar,
    BIconStarFill,
    BIconStarHalf,
    BIconStop,
    BIconStopFill,
    BIconStopwatch,
    BIconStopwatchFill,
    BIconSubtract,
    BIconSun,
    BIconTable,
    BIconTablet,
    BIconTabletLandscape,
    BIconTag,
    BIconTagFill,
    BIconTerminal,
    BIconTerminalFill,
    BIconTextCenter,
    BIconTextIndentLeft,
    BIconTextIndentRight,
    BIconTextLeft,
    BIconTextRight,
    BIconTextarea,
    BIconTextareaT,
    BIconThreeDots,
    BIconThreeDotsVertical,
    BIconToggleOff,
    BIconToggleOn,
    BIconToggles,
    BIconTools,
    BIconTrash,
    BIconTrash2,
    BIconTrash2Fill,
    BIconTrashFill,
    BIconTriangle,
    BIconTriangleFill,
    BIconTriangleHalf,
    BIconTrophy,
    BIconTv,
    BIconTvFill,
    BIconType,
    BIconTypeBold,
    BIconTypeH1,
    BIconTypeH2,
    BIconTypeH3,
    BIconTypeItalic,
    BIconTypeStrikethrough,
    BIconTypeUnderline,
    BIconUnion,
    BIconUnlock,
    BIconUnlockFill,
    BIconUpload,
    BIconViewList,
    BIconViewStacked,
    BIconVolumeDown,
    BIconVolumeDownFill,
    BIconVolumeMute,
    BIconVolumeMuteFill,
    BIconVolumeUp,
    BIconVolumeUpFill,
    BIconVr,
    BIconWallet,
    BIconWatch,
    BIconWifi,
    BIconWindow,
    BIconWrench,
    BIconX,
    BIconXCircle,
    BIconXCircleFill,
    BIconXDiamond,
    BIconXDiamondFill,
    BIconXOctagon,
    BIconXOctagonFill,
    BIconXSquare,
    BIconXSquareFill
  }
})

// Export the BootstrapVueIcons plugin installer
// Mainly for the stand-alone bootstrap-vue-icons.xxx.js builds
export const BootstrapVueIcons = /*#__PURE__*/ pluginFactoryNoConfig(
  { plugins: { IconsPlugin } },
  { NAME: 'BootstrapVueIcons' }
)

// --- END AUTO-GENERATED FILE ---
